<template>
    <div>

        <div @click.prevent="clickedCheckoutStep('/store/checkout/?step=shipping')" @keydown.enter.prevent="clickedCheckoutStep('/store/checkout/?step=shipping')" @keydown.space.prevent="clickedCheckoutStep('/store/checkout/?step=shipping')" role="button" tabindex="0" class="buy-now-row" data-log="shipping-edit-request">
            <div class="buy-now-row__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>map-marker-outline</title>
                    <path d="M12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5M12,2A7,7 0 0,1 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9C7,10 7,12 12,18.71C17,12 17,10 17,9A5,5 0 0,0 12,4Z" />
                </svg>
            </div>
            <div class="buy-now-row__content">
                <div class="buy-now-row__title">Shipping Location</div>
                <b class="fs-mask">{{ userInfo.shipping.name }}</b>
                <p class="address-line fs-mask" v-for="address_line in userInfo.shipping.address_lines" :key="address_line">
                    {{ address_line }}
                </p>
            </div>
            <div class="buy-now-row__help">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="#A9A9A9" stroke-width="1.5"/>
                </svg>
            </div>
            <div class="buy-now-tooltip">
                Click to visit the full checkout experience where you can edit options.
            </div>
        </div>

        <div @click.prevent="clickedCheckoutStep('/store/checkout/?step=shippingmethod')" @keydown.enter.prevent="clickedCheckoutStep('/store/checkout/?step=shippingmethod')" @keydown.space.prevent="clickedCheckoutStep('/store/checkout/?step=shippingmethod')" role="button" tabindex="0" class="buy-now-row" v-if="userInfo.shipping.delivery_date" data-log="delivery-edit-request">
            <div class="buy-now-row__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>truck-fast-outline</title>
                    <path d="M.75 7.5H10.5L11.25 9H1.5L.75 7.5M1.75 10.5H11.5L12.25 12H2.5L1.75 10.5M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5M8 18.5C8.83 18.5 9.5 17.83 9.5 17C9.5 16.17 8.83 15.5 8 15.5C7.17 15.5 6.5 16.17 6.5 17C6.5 17.83 7.17 18.5 8 18.5M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H11C11 18.66 9.65 20 8 20C6.34 20 5 18.66 5 17H3V13.5 13.5H5V15H5.76C6.31 14.39 7.11 14 8 14C8.89 14 9.69 14.39 10.24 15H15V6H3V6C3 4.89 3.89 4 5 4H17V8H20Z" />
                </svg>
            </div>
            <div class="buy-now-row__content">
                <div class="buy-now-row__title">Delivery</div>
                <b>
                    <span v-if="userInfo.pricing.shipping == 0" class="buy-now__free">FREE</span>
                    <span v-else-if="userInfo.pricing.shipping">${{ userInfo.pricing.shipping }}</span>
                    Est. Delivery {{ userInfo.shipping.delivery_date }}
                </b>
            </div>
            <div class="buy-now-row__help">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="#A9A9A9" stroke-width="1.5"/>
                </svg>
            </div>
            <div class="buy-now-tooltip">
                Click to visit the full checkout experience where you can edit options.
            </div>
        </div>

        <div @click.prevent="clickedCheckoutStep('/store/checkout/?step=payment')" @keydown.enter.prevent="clickedCheckoutStep('/store/checkout/?step=payment')" @keydown.space.prevent="clickedCheckoutStep('/store/checkout/?step=payment')" role="button" tabindex="0" class="buy-now-row" v-if="userInfo.cc"  data-log="payment-edit-request">
            <div class="buy-now-row__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>credit-card-check-outline</title>
                    <path d="M13 19C13 18.66 13.04 18.33 13.09 18H3V12H19V13C19.7 13 20.37 13.13 21 13.35V6C21 4.89 20.11 4 19 4H3C1.89 4 1 4.89 1 6V18C1 19.1 1.89 20 3 20H13.09C13.04 19.67 13 19.34 13 19M3 6H19V8H3V6M17.75 22L15 19L16.16 17.84L17.75 19.43L21.34 15.84L22.5 17.25L17.75 22" />
                </svg>
            </div>
            <div class="buy-now-row__content">
                <div class="buy-now-row__title">Payment Info</div>
                <span v-if="isDigitsOnly(userInfo.cc.detail)">•••• •••• •••• </span><b class="fs-mask">{{ userInfo.cc.detail }} <span v-if="userInfo.cc.detail && userInfo.cc.type">|</span> {{ userInfo.cc.type }}</b>
            </div>
            <div class="buy-now-row__help">
                <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 7L1 13" stroke="#A9A9A9" stroke-width="1.5"/>
                </svg>
            </div>
            <div class="buy-now-tooltip">
                Click to visit the full checkout experience where you can edit options.
            </div>
        </div>

        <div>
            <table class="pricing-table">
                <tr>
                    <td>
                        Subtotal
                    </td>
                    <td>
                        {{ formatPrice(userInfo.pricing.sub_total) }}
                    </td>
                </tr>
                <tr>
                    <td>Sales Tax</td>
                    <td>
                        {{ formatPrice(userInfo.pricing.tax_estimate) }}
                    </td>
                </tr>
                <tr>
                    <td>
                        Shipping
                    </td>
                    <td>
                        <span v-if="userInfo.pricing.shipping == 0" class="buy-now__free">FREE</span>
                        <span v-else>{{ formatPrice(userInfo.pricing.shipping) }}</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <b>Grand Total</b>
                    </td>
                    <td>
                        <b>{{ formatPrice(userInfo.pricing.order_total) }}</b>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import logBuyNowRedirectToCheckoutReason from './logBuyNowRedirectToCheckoutReason';
    export default {
        props: {
            userInfo: {
                required: true,
            },
            multiItem: {
                type: Boolean,
                default: false,
                required: false
            },
            showEdit: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        mounted() {
            //
        },
        methods: {
            clickedCheckoutStep(url) {
                this.$emit('clicked-checkout-step', url);
            },
            formatPrice(value) {
                let formatting_options = {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                }
                let dollarString = new Intl.NumberFormat("en-US", formatting_options);
                let finalString = dollarString.format(value);
                return(finalString);
            },
            isDigitsOnly(str) {
                return /^\d+$/.test(str);
            }
        }
    }
</script>

<style lang="scss" scoped>
.pricing-table {
    color: #7C7C7C;
    font-weight: lighter;
    font-size: 0.8em;
    margin: 1em 0 1em 80px;
    min-width: 250px;
}

b {
    color: #202020;
}

.buy-now-row,
a.buy-now-row {
    color: #2f2f2f!important;
    display: flex;
    align-items: center;
    border-bottom: solid 1px #e3e6ec;
    padding: 1rem 0;
    position: relative;
    text-decoration: none;
    cursor: pointer;

    &__content {
        flex-grow: 1;
    }
    &__help {
        padding: .5rem 1rem;
    }

    &__icon {
    text-align: center;
    width: 80px;

        svg {
            width: 1.8em !important;
            height: auto !important;
            opacity: 0.7;
        }
    }

    &__title {
        font-weight: 600;
        font-size: .825rem;
        margin-bottom: 0.25em;
        @media screen and (max-height:600px) {
            display: none;
        }
    }

    &:hover {
        background: #f6f8fd;
        color: #222!important;
        .buy-now-tooltip {
            display: block;
        }
    }
}

.buy-now__free {
    font-weight: 600;
    color: #3b7d1a;
}


.address-line {
    font-size: 0.8em;
    font-weight: lighter;
}

.buy-now-tooltip {
    position: absolute;
    top: 100%;
    background: #222;
    color: #fff;
    padding: 1em;
    font-size: .8rem;
    border-radius: 4px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 1;
    display: none;
    width: 250px;
    max-width: 90%;
    pointer-events: none;

    &::before {
        content:'';
        border: 8px solid transparent;
        border-bottom: 8px solid #222;
        left: 50%;
        top: -16px;
        margin-left: -8px;
        position: absolute;
    }
}

#buy-now-visitcheckout {
    background: none;
    border-bottom: 1px solid #e3e6ec;
    color: #222 !important;
    display: inline-block;
    padding: 1em;
    text-align: center;
    text-decoration: underline;
    width: 100%;
    box-sizing: border-box;
    &:hover {
        color: #0072ba!important;
    }
}
</style>
